import React from 'react';
import { t } from 'src/i18n';
import Routes from '../../modules/Navigator/Navigator.route';
import { BottomLink } from './SignInAsGuestLink.style';

const SignInAsGuestLink: React.FC = () => {

  const directLocation = (pathName) => {
    return pathName;
  };

  return (
    <BottomLink to={directLocation(Routes.Dashboard)}>
      {t('general.accessWithoutAccount')}
    </BottomLink>
  );
};

export default SignInAsGuestLink;
